<template>
  <vs-sidebar
    click-not-close
    hidden-background
    position-right
    v-model="active"
    class="items-no-padding department-edit">
    <div class="h-full">

      <div class="customizer-header flex items-center justify-between px-6 sliderbar-header">
        <div class="dialog-title">
          {{title}}
        </div>
        <feather-icon icon="XIcon" @click.stop="closeHandle" class="cursor-pointer"></feather-icon>
      </div>
      <VuePerfectScrollbar class="scroll-area--customizer pt-4 pb-6" :settings="settings" :key="$vs.rtl">

        <div class="px-6">
          <el-form
            :model="form"
            :rules="rules"
            hide-required-asterisk
            label-position="top"
            ref="form"
          >
            <el-form-item
              label="产品"
              prop="product"
            >
              <el-select
                v-model="form.product"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in products"
                  :key="index"
                  :label="item.productName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="渠道"
              prop="channel"
            >
              <el-select
                v-model="form.channel"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in channels"
                  :key="index"
                  :label="item.channelName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="状态"
              prop="status"
              class="blod-form-item"
            >
              <vs-radio
                v-model="form.status"
                vs-name="radios1"
                class="mar-right10"
                :vs-value="0"
              >启用</vs-radio>
              <vs-radio
                v-model="form.status"
                vs-name="radios1"
                class=""
                :vs-value="1"
              >禁用</vs-radio>
            </el-form-item>
            <el-form-item>
              <vs-button @click="submit" class="mar-right10" type="filled" color="primary">确认</vs-button>
              <vs-button @click="cancel" type="border"  color="primary">取消</vs-button>
            </el-form-item>
          </el-form>
        </div>
      </VuePerfectScrollbar>
    </div>
  </vs-sidebar>
</template>

<script>
  import { queryValidChannels } from '@/api/channel'
  import { queryValidProducts, createProdChannelRelation,updateMerProdRelation } from '@/api/product'
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
    export default {
      name: "editOrAdd",
      props: {
        active: {
          type: Boolean,
          default: false
        },
        isEdit:{
          type: Boolean,
          default: false
        },
        editData:{
          type: Object,
          default(){
            return {
              name: '',
              product: '',
              status: 0,
            }
          }
        }
      },
      components: {
        VuePerfectScrollbar,
      },
      data() {
          let validatorId = (rule, value, callback) => {
            if(value === ''){
              callback(new Error('请选择'));
            }else {
              callback();
            }
          };
        return {
          settings: {
            maxScrollbarLength : 60,
            wheelSpeed         : .60,
          },
          form:{
            product: '',
            channel: '',
            status: 0,
          },
          rules:{
            // 名字有长度限制以及不能输入空格
            product:[
              { required: true, message: '请选择', trigger: 'blur' }
            ],
            channel:[
              { required: true, message: '请选择', trigger: 'change' }
            ],
          },
          channels: [],
          products: [],
        }
      },
      created(){
        this.getProducts();
        this.getChannels();
      },
      watch: {
        editData(newValue, oldValue) {
          if(newValue){
            this.form.id = newValue.id;
            this.form.product = newValue.productId;
            this.form.channel = newValue.channelId;
            this.form.status = newValue.status;
          }else {
            this.form = {
              product: '',
              channel: '',
              status: 0,
            }
          }
        },
        active(newValue){
          if(newValue){
            this.$refs.form.clearValidate();
          }
        }
      },
      computed: {
        title() {
          return this.isEdit ? '编辑': '添加';
        }
      },
      methods: {
        getProducts(){
          queryValidProducts({isValid: 1}).then((res) => {
            console.log(res);
            this.products = res.data;
          })
        },
        getChannels(){
          queryValidChannels({isValid: 1}).then((res) => {
            console.log(res);
            this.channels = res.data.content;
          })
        },
        close(){
          this.reset();
          this.$emit('close')
        },
        reset(){
          this.form = {
            product: '',
            channel: '',
            status: 0,
          };
        },
        closeHandle() {
          this.reset();
          this.$refs.form.resetFields();
          this.close();
        },
        cancel(){
          this.$refs.form.resetFields();
          this.close();
        },
        submit(){
            this.$refs.form.validate((valid) => {
              if(valid){
                let params = {
                  productId: this.form.product,
                  channelId: this.form.channel,
                  status: this.form.status,
                }
                if(this.isEdit){
                  params.id = this.form.id;
                  updateMerProdRelation(params).then((res) => {
                    console.log(res);
                    this.close();
                    this.$emit('done-success');
                    this.$vs.notify({
                      text: '操作成功',
                      position: 'top-right'
                    })
                  })
                }else {
                  createProdChannelRelation(params).then((res) => {
                    console.log(res);
                    this.close();
                    this.$emit('done-success');
                    this.$vs.notify({
                      text: '操作成功',
                      position: 'top-right'
                    })
                  })
                }
              }else {

              }
            })
        }
      },
    }
</script>

<style lang="scss">
  .department-edit {
    .vs-sidebar {
      position: fixed;
      z-index: 999;
      width: 360px;
      max-width: 90vw;
      // @apply shadow-lg;
      box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,0.08);
    }
    .scroll-area--customizer {
      height: calc(100% - 5rem);
    }
    .el-select {
      width: 100%;
    }
  }


</style>
